import { render } from "./IconDownLoad.vue?vue&type=template&id=5a9cabe0"
import script from "./IconDownLoad.vue?vue&type=script&lang=js"
export * from "./IconDownLoad.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__